// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class FeatureFlag {
  readonly isEnabled: boolean;
  readonly name: Enums.FeatureFlagName;

  constructor(data: { [key: string]: any } = {}) {
    this.isEnabled = data.isEnabled === undefined ? false : data.isEnabled;
    this.name = data.name === undefined ? Enums.FeatureFlagName.TestDummy : data.name;
  }

  static zero(): FeatureFlag {
    const zeroValues: ExcludeMethodsDeep<FeatureFlag> = {
      isEnabled: false,
      name: Enums.FeatureFlagName.TestDummy,
    };
    return new FeatureFlag(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type FeatureFlagWireFormat = {
  isEnabled: boolean;
  name: string;
};

type NewFeatureFlagProps = PartialDeep<FeatureFlag, { recurseIntoArrays: true }>;
export const NewFeatureFlag: (props: NewFeatureFlagProps) => FeatureFlag = (props) =>
  new FeatureFlag(props);

type NewFeatureFlagFromWireFormatProps = PartialDeep<
  FeatureFlagWireFormat,
  { recurseIntoArrays: true }
>;
export const NewFeatureFlagFromWireFormat: (
  props: NewFeatureFlagFromWireFormatProps,
) => FeatureFlag = (props) => new FeatureFlag(props);
